import React, { useState } from "react";

const Accordion = ({ title, children, defaultOpen = true }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="bg-white rounded-lg h-full">
      <button
        onClick={toggleAccordion}
        className="w-full flex justify-between items-center p-4 hover:bg-gray-50 focus:outline-none transition-colors duration-200"
      >
        <h3 className="text-lg font-medium text-gray-900">{title}</h3>
        <div className="flex items-center">
          <span
            className={`text-gray-500 text-xl transition-transform duration-300 ${
              isOpen ? "rotate-180" : ""
            }`}
          >
            ▼
          </span>
        </div>
      </button>
      <div
        className={`transition-all duration-300 ease-in-out ${
          isOpen ? "max-h-[2000px] opacity-100" : "max-h-0 opacity-0"
        } overflow-hidden`}
      >
        <div className="p-4 border-t border-gray-100">{children}</div>
      </div>
    </div>
  );
};

export default Accordion;
